import { css } from "@emotion/react";
import { theme } from "styles/theme";

export const SubGameNewMobileStyle = {
  wrapper: css`
    margin-bottom: 52px;
  `,

  mainContent: css`
    display: grid;
    grid-template-columns: repeat(4, 1fr);

    .show-categories {
      height: 666px !important;
    }
  `,

  categoryGame: css`
    position: sticky;
    top: 71px;
    height: 583px;
    overflow-y: scroll;
    overflow-x: hidden;

    grid-column-start: 1;
    grid-column-end: 2;

    padding-right: 7px;
  `,

  categoryGameItem: (isActive: boolean) => css`
    position: relative;
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;

    margin-bottom: 3px;
    padding: 3px 8px;

    background-color: ${isActive ? "#ff9000" : "#353535"};
    border-radius: 0px 10px 10px 0px;

    &::before {
      content: "";
      position: absolute;
      top: calc(50% - 7px);
      right: -8px;
      width: 0;
      height: 0;
      border-width: 7px 0 7px 8px;
      border-style: solid;
      border-color: transparent;
      border-left-color: ${isActive ? `rgb(255 144 0 / 1)` : "#111111"};
    }
    span {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: white;

      text-align: center;
    }
    img {
      max-width: 60px;
    }
  `,

  subGame: css`
    grid-column-start: 2;
    grid-column-end: 5;

    margin-left: 11.7px;
  `,

  empty: css`
    height: 500px !important;
    justify-content: center !important;
    display: flex !important;
    flex-direction: column !important;

    .ant-empty-description {
      color: ${theme.colors.white} !important;
    }
  `,

  listSubGame: css`
    padding-right: 10px;

    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 12px;
    column-gap: 7px;
  `,

  cardCategoryGame: css`
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;

      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  `,

  cardSubGame: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    img {
      width: 100%;
      aspect-ratio: 1 / 1;
      object-fit: cover;
    }
  `,

  nameCardItem: css`
    width: 100%;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14.4px;

    color: ${theme.colors.white};
    text-align: center;

    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  `,

  filterGame: {
    index: css`
      padding: 11.69px 7.8px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    `,

    boxWrap: css`
      display: flex;
      gap: 6px;
    `,

    search: css`
      input {
        border-radius: 4px !important;
        &::placeholder {
          border-color: ${theme.colors.white} !important;
        }
      }
      .ant-input-affix-wrapper {
        input {
          padding: 0 6px;
        }
      }
    `,
    select: css`
      flex: 1;

      border-radius: 5px;
      color: #757575;
    `,
  },

  boxFilter: (isSelected: boolean) => css`
    display: flex;
    align-items: center;

    padding: 8px 17px;
    border-radius: 4px;
    background-color: ${theme.colors.secondary[450]};
    opacity: ${isSelected ? "1" : "0.4"};
    span {
      color: ${theme.colors.white};
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 10px;
    }
  `,

  paginationWrap: () => css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    margin-right: 11.7px;
  `,

  paginationItem: () => css`
    .ant-pagination-item-ellipsis {
      color: ${theme.colors.white} !important;
    }
    .ant-pagination-next button {
      color: ${theme.colors.secondary[900]} !important;
    }
    .ant-pagination-prev button {
      color: ${theme.colors.secondary[900]} !important;
    }
    .ant-pagination-disabled button:disabled {
      color: ${theme.colors.secondary[900]} !important;
    }
    .ant-pagination-item-active {
      border-color: ${theme.colors.red[100]} !important;
    }
    .ant-pagination-item a {
      color: ${theme.colors.white} !important;
    }
    .ant-pagination-item-active a {
      color: ${theme.colors.red[100]} !important;
    }
  `,

  titleSubGame: css`
    margin-bottom: 5px;
    padding: 0 5px;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      background: ${theme.colors.red[150]};
      height: 2px;
      width: 260px;

      bottom: 0px;
      left: 15px;
    }
    span {
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 30px;

      color: ${theme.colors.white};
      background-color: ${theme.colors.red[150]};
      border-radius: 10px;
      padding: 8px 5px;
    }
  `,
};
